<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCancelClick()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Request Details</h4>
</div>

<div class="modal-body">
    <form [formGroup]="requestForm">
        <fieldset>
            <div class="row">
                <div class="col-7 mvd_form-group">
                    <label class="required"title="* Required">Who has requested {{actionName}} this mDL?</label>
                    <p-dropdown [options]="reasonTypeIdOptions" placeholder=" " formControlName="reasonTypeId"></p-dropdown>
                </div>
            </div>
        </fieldset>
    </form>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="onCancelClick()">Cancel</button>
        <button class="btn--primary" [disabled]="!requestForm.valid" type="button" (click)="onAcceptClick()">OK</button>
    </div>
</div>
